import { useMutation } from '@tanstack/react-query';

import { RiskAssessmentTemplatesApi } from 'api/RiskAssessmentTemplatesApi';
import { getSnackbarStore } from 'stores/SnackBarStore';
import { useFiRiskAssessmentCache } from 'tanstack-hooks/fi-risk-assessments/risk-assessments-cache';
import { RISK_ASSESSMENT_TEMPLATES_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';
import { getPublishErrorMessage } from 'ui/apps/fi/util/get-publish-error-message';

export function usePublishRiskAssessmentTemplate() {
  const riskAssessmentTemplatesApi = new RiskAssessmentTemplatesApi();
  const { userBankId } = useUser();
  const { invalidateRiskAssessmentTemplates } = useFiRiskAssessmentCache();

  const { mutate: publishRiskAssessmentTemplate, isPending: isPublishingRiskAssessmentTemplate } =
    useMutation({
      mutationKey: [RISK_ASSESSMENT_TEMPLATES_KEY, 'publish'],
      mutationFn: (id: string) => riskAssessmentTemplatesApi.publishRiskAssessmentTemplate(userBankId, id),
      onSuccess: () => {
        invalidateRiskAssessmentTemplates();
      },
      onError: (error) => {
        getSnackbarStore().showErrorSnackbarMessage(getPublishErrorMessage(error));
      },
      meta: {
        snackbarSuccessMessage: 'Template published.'
      }
    });

  return { publishRiskAssessmentTemplate, isPublishingRiskAssessmentTemplate };
}
